// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'
import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    name: 'PreviousPolicies',
    components: {
        IconArrowBack,
        IconBase,
        IconCheck,
        IconForwardBack,
        BackButton,
        NextButton
    }, 
    data: () => ({  
    }),
    methods: {
        Next(_previouspolicies) {
            this.$parent.EducatorInsuranceProcess.previous_policies = _previouspolicies;
            this.$parent.EducatorNextStep(4,"PreviousClaims");
        },
        ValidateSessionData() {
            if(this.$parent.EducatorInsuranceProcess.previous_policies != null) {
                if(this.$parent.EducatorInsuranceProcess.previous_policies) {
                    document.getElementById("Yes").classList.add("selected");
                } else {
                    document.getElementById("No").classList.add("selected");
                }
            }
        }
    },
    mounted(){
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
        this.$parent.CheckWindowPathName();
        this.ValidateSessionData();
        
        this.$parent.RemoveClassFrom('button-item','b-btn');
        this.$parent.AddClassFrom('button-item','wh-btn');
        if (this.$parent.EducatorInsuranceProcess.previous_policies == true) {
            document.getElementById('Yes').classList.add("b-btn");
            document.getElementById('Yes').classList.remove("wh-btn");
        } else if (this.$parent.EducatorInsuranceProcess.previous_policies == false) {
            document.getElementById('No').classList.add("b-btn");
            document.getElementById('No').classList.remove("wh-btn");
        }
    }
}